




























import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import ConversationRow from "./components/conversation-row.vue";
import { getConversations, getUnreadMessageCount } from "@/api/net/im";
import Scroller from "@/components/Scroll.vue";
import {
  GetCurrentConversationsResponse,
  ConversationDto,
  CommunicationParty
} from "@/types/interface/IM/IMTypes";
import { Getter, Mutation } from "vuex-class";
import {
  TrackableMessageDto,
  MessageDto,
  GetTotalUnReadCountRequest
} from "../../types/interface/IM/IMTypes";
import store from "../../store/index";
import { refreshTimeLimitMessage } from "../../api/signalR";

@Component({
  components: {
    ConversationRow,
    Scroller
  }
})
export default class Home extends Vue {
  @Getter("newMessage") newMessage!: MessageDto;
  @Getter("isPc") isPc!: boolean;
  @Watch("newMessage")
  async onNewMessageArrived(newValue: MessageDto) {
    // if (!refreshTimeLimitMessage()) {
    //   return;
    // }
    await this.getConversations();
  }

  @Mutation("handleKeyword")
  private handleKeyword: Function;

  conversations: ConversationDto[] = [];
  pageIndex: number = 1;
  activePaging: boolean = false;
  totalPage: number = 0;
  queryString: string = "";
  exactSearch: boolean = store.state.exactSearch;

  public get searchPlaceholeder(): string {
    if (this.exactSearch) {
      return `Search by order number e.g. ORD000012345 or 12345`;
    } else {
      return `Search order number, user name and message content`;
    }
  }

  changeExactSearch() {
    store.commit("handleExactSearch", this.exactSearch);
  }

  public get moreThanCurrentPage(): number[] {
    let numberList = [];
    for (
      let index = this.pageIndex + 1;
      index < this.pageIndex + 3 && index <= this.totalPage;
      index++
    ) {
      numberList.push(index);
    }
    return numberList;
  }

  public get lessThanCurrentPage(): number[] {
    let numberList = [];
    for (
      let index = this.pageIndex - 1;
      index > this.pageIndex - 3 && index > 0;
      index--
    ) {
      numberList.push(index);
    }
    return numberList.sort((a, b) => a - b);
  }

  async toPage(page: number, queryString: string) {
    this.pageIndex = page;
    store.commit("handleShowLoading", true);
    store.commit("handleCurrentMessagePage", page);
    this.conversations = [
      ...(await getConversations(
        page,
        store.state.keyword,
        store.state.exactSearch
      ))
    ];
    store.commit("handleShowLoading", false);
  }

  async getConversations() {
    this.conversations = [
      ...(await getConversations(
        store.state.currentMessagePage,
        store.state.keyword,
        store.state.exactSearch
      ))
    ];

    const request: GetTotalUnReadCountRequest = {
      merchIds: [],
      orderIds: [],
      userIds: [],
      requestFrom: CommunicationParty.merchant
    };

    //-----------PC端拉取不同餐馆数据时会重复拉取相同的IM消息，需要过滤
    if (this.isPc) {
      this.conversations = this.conversations.reduce(
        (arr: ConversationDto[], item: ConversationDto) => {
          let isExistItem = arr.find(x => x.id === item.id);
          if (!isExistItem) {
            arr = [...arr, item];
          }
          return arr;
        },
        []
      ) as ConversationDto[];
      //----------------------------------------------------

      request.merchIds = store.state.merchIds;
    }
    if (this.conversations.length) {
      this.totalPage = Math.ceil(this.conversations[0].conversationTotal / 10);
    }

    getUnreadMessageCount(request);
    store.commit("handleShowLoading", false);
  }

  listHeight: number = 1024;

  // async scrollToEnd(event: any) {
  //   if (event.y < -600) {
  //     this.pageIndex += 1;
  //     store.commit("handleShowLoading", true);
  //     await this.getConversations();
  //   }
  // }

  // startClient: number;
  // windowWidth = window.screen.width;
  // touchstartFunc(e: any) {
  //   this.startClient = e.touches[0].clientX;
  // }
  // touchEndFunc(e:any) {
  //   let endClient = e.changedTouches[0].clientX;
  //   if(Math.abs(this.startClient - endClient) > this.windowWidth / 4) {
  //     this.$router.push({ name: 'Settings' });
  //   }
  // }

  async search() {
    store.commit("handleShowLoading", true);
    store.commit("handleKeyword", this.queryString);
    store.commit("handleCurrentMessagePage", 1);
    this.pageIndex = 1;
    try {
      if (this.queryString) {
        this.conversations = [
          ...(await getConversations(
            this.pageIndex,
            this.queryString,
            store.state.exactSearch
          ))
        ];
      } else {
        this.conversations = [
          ...(await getConversations(
            this.pageIndex,
            this.queryString,
            store.state.exactSearch
          ))
        ];
      }

      if (this.isPc) {
        let maxTotalConversations: number = this.conversations.reduce(
          (total: number, currentItem: ConversationDto) => {
            if (currentItem.conversationTotal > total) {
              return (total = currentItem.conversationTotal);
            }
            return total;
          },
          0
        );
        this.totalPage = Math.ceil(maxTotalConversations / 5);
        return;
      } else {
        this.totalPage = Math.ceil(
          this.conversations[0].conversationTotal / 10
        );
      }
    } catch (e) {
    } finally {
      store.commit("handleShowLoading", false);
    }
  }

  async updateConversationList() {
    this.$store.commit("handleShowLoading", true);
    await this.getConversations();
    this.$store.commit("handleShowLoading", false);
  }

  async mounted() {
    this.$store.commit("handleShowLoading", true);
    await this.getConversations();
    this.$store.commit("handleShowLoading", false);
    this.queryString = store.state.keyword;
    this.pageIndex = store.state.currentMessagePage;
    this.listHeight = document.body.offsetHeight - 183;
    store.commit("handleShowLoading", false);
  }
}
